import { useEffect } from "react";
import { Link } from "react-router-dom";
import MetedStaticData from "./data_sets/MetedStaticData";
import Footer from "./Footer";
import { connect } from "react-redux";
import { getFullLesson } from "../../actions";
import { useParams } from "react-router-dom";
import {
  ArrowTopRightOnSquareIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";
import { FormattedMessage } from "react-intl";

import { GrTechnology } from "react-icons/gr";
import { RiRobot2Line } from "react-icons/ri";
import { TfiRulerPencil } from "react-icons/tfi";
import { IoBookOutline } from "react-icons/io5";

const JoinFeaturedContainer = (props) => {
  const { dispatch, viewer } = props;
  const { locale } = viewer.language;
  const posts = locale === "es_ES" ? MetedStaticData.latestFeaturedSpanish : MetedStaticData.latestFeatured;
  const params = useParams();


  //Init hook to check logged in state
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getFullLesson(params.id));
  }, [dispatch, params.id]);

  // Add state for animated stats
  /*const [animatedStats, setAnimatedStats] = useState([]);

  // Animation effect when component mounts
  useEffect(() => {
    // Initialize animated stats to zero
    setAnimatedStats(MetedStats.map(() => 0));

    // Extract numerical values from stat values
    const finalValues = MetedStats.map((stat) => {
      // Extract digits from the value
      const numStr = stat.value.toString().replace(/[^\d.]/g, "");
      return parseFloat(numStr) || 0;
    });

    const duration = 600; // animation duration in ms
    const frameRate = 16; // Update roughly every 16ms (60fps)
    const frames = duration / frameRate;

    // Calculate increment per frame for each stat
    const incrementsPerFrame = finalValues.map((val) => val / frames);

    let frameCount = 0;
    const timer = setInterval(() => {
      frameCount++;
      if (frameCount <= frames) {
        setAnimatedStats((prev) =>
          prev.map((val, i) => {
            const newVal = Math.min(
              val + incrementsPerFrame[i],
              finalValues[i]
            );
            return newVal;
          })
        );
      } else {
        clearInterval(timer);
        // Ensure we end with the exact final values
        setAnimatedStats(finalValues);
      }
    }, frameRate);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [MetedStats]);*/

  // Format number for display
  /*const formatNumber = (value) => {
    return Math.round(value).toLocaleString();
  };*/

  return (
    <section id="meted-landing">
      {/* LATEST METED CHANGES */}
      <aside className="text-center py-4 bg-amber-400 relative">
          <Link to="/updates" className="text-lg underline hover:text-[#1A658F] hover:no-underline block sm:absolute inset-0">
            <FormattedMessage
              id="meted.latest_changes"
              defaultMessage="Learn more about the latest MetEd look and experience!"
            />
          </Link>
      </aside>
      {/* WELCOME TO METED */}
      <div className="relative isolate overflow-hidden bg-gradient-to-tr from-[#012993] to-[#00c1ff] py-8 sm:py-12 min-h-[350px] px-4 sm:px-6 lg:px-8">
        <div className="absolute inset-0">
          <img
            src={
              process.env.PUBLIC_URL + "/static/img/MetEd_banner.png" ||
              "/placeholder.svg?height=400&width=600"
            }
            alt="COMET MetEd Banner"
            className="absolute inset-0 w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#012993] to-transparent"></div>
        </div>
        <div className="relative max-w-7xl mx-auto">
          <div className="grid gap-6 lg:grid-cols-2 md:gap-12 items-center">
            <div className="space-y-6">
              <h1 className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl text-white">
                <FormattedMessage
                  id="meted.welcome_label"
                  defaultMessage="Welcome to MetEd!"
                />
              </h1>
              <p className="text-lg md:text-xl text-white/90">
                <FormattedMessage
                  id="meted.meted_is_blurb"
                  defaultMessage="MetEd offers thousands of free education & training resources for the weather and geosciences community. Whether you're an experienced meteorologist honing existing skills or a student ready explore and learn new topics, we have something for you."
                />
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="https://learn.meted.ucar.edu/#/public-dashboard"
                  className="inline-flex items-center justify-center bg-[#1A658F] px-6 py-3 text-base font-medium text-white shadow-lg hover:bg-cyan-600 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 rounded-md"
                >
                  <FormattedMessage
                    id="meted.explore_catalog"
                    defaultMessage="Explore Catalog"
                  />
                  <ChevronRightIcon className="ml-2 h-4 w-4" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* METED STATS & INFO */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="mb-8 flex flex-col items-center text-center">
          <h2 className="text-3xl font-bold tracking-tight text-[#1A658F]">
            <FormattedMessage
              id="meted.what_we_offer"
              defaultMessage="What Our Education and Training Catalog Offers"
            />
          </h2>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex flex-col items-center p-6 text-center">
              <GrTechnology className="h-12 w-12" color="#1a658f" />
              <h3 className="mt-4 font-semibold text-lg">
                <FormattedMessage
                  id="meted.personalized_learning"
                  defaultMessage="Personalized Learning"
                />
              </h3>
              <ul className="mt-2 text-muted-foreground list-disc list-inside">
                <li>
                  <FormattedMessage
                    id="meted.private_learning_dashboard"
                    defaultMessage="Private learning dashboard with access to your courses, catalog, and transcript"
                  />
                </li>
                <li>
                  <FormattedMessage
                    id="meted.progress_tracking_tools"
                    defaultMessage="Progress-tracking tools"
                  />
                </li>
                <li>
                  <FormattedMessage
                    id="meted.streamlined_notifications"
                    defaultMessage="Streamlined notifications and communication"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div className="flex flex-col items-center p-6 text-center">
              <IoBookOutline className="h-12 w-12" color="#1a658f" />
              <h3 className="mt-4 font-semibold text-lg">
                <FormattedMessage
                  id="meted.training_resources"
                  defaultMessage="Training Resources"
                />
              </h3>
              <ul className="mt-2 text-muted-foreground list-disc list-inside">
                <li>
                  <FormattedMessage
                    id="meted.courses_webinars_more"
                    defaultMessage="Courses, webinars, training, and more"
                  />
                </li>
                <li>
                  <FormattedMessage
                    id="meted.enhanced_accessibility"
                    defaultMessage="Enhanced accessibility features"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div className="flex flex-col items-center p-6 text-center">
              <TfiRulerPencil className="h-12 w-12" color="#1a658f" />
              <h3 className="mt-4 font-semibold text-lg">
                <FormattedMessage
                  id="meted.optimized_online_learning"
                  defaultMessage="Optimized online learning through simulations"
                />
              </h3>
              <ul className="mt-2 text-muted-foreground list-disc list-inside">
                <li>
                  <FormattedMessage
                    id="meted.real_world_scenarios"
                    defaultMessage="Exploration of real-world scenarios, skills, and tools"
                  />
                </li>
                <li>
                  <FormattedMessage
                    id="meted.interactive_simulations"
                    defaultMessage="Interactive simulations"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div className="flex flex-col items-center p-6 text-center">
              <RiRobot2Line className="h-12 w-12" color="#1a658f" />
              <h3 className="mt-4 font-semibold text-lg">
                <FormattedMessage
                  id="meted.advanced_ai_tools"
                  defaultMessage="Advanced AI tools"
                />
              </h3>
              <ul className="mt-2 text-muted-foreground list-disc list-inside">
                <li>
                  <FormattedMessage
                    id="meted.personalized_recommendations"
                    defaultMessage="Personalized course recommendations powered by Artificial Intelligence"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* RECENT PUBLICATIONS */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gray-100">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8">
            <h2 className="text-3xl font-bold tracking-tight text-[#1A658F]">
              <FormattedMessage
                id="meted.latest_resources"
                defaultMessage="Latest Resources"
              />
            </h2>
            <p className="mt-2 text-muted-foreground">
              <FormattedMessage
                id="meted.recent_publications_blurb"
                defaultMessage="Explore our latest educational and training resources."
              />
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            {posts.map((post, index) => (
              <a
                key={index}
                href={post.href || "#"}
                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-200 flex flex-col h-full border border-solid border-gray-200 hover:-translate-y-1"
              >
                <img
                  src={post.imageUrl || "/placeholder.svg?height=200&width=400"}
                  alt={post.title || "THUMBNAIL"}
                  width={400}
                  height={200}
                  className="aspect-video w-full object-cover bg-gray-400/20"
                />
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-xl font-semibold text-gray-800">
                    {post.title}
                  </h3>
                  <p className="mt-2 text-sm text-muted-foreground pb-4 text-gray-600">
                    {post.description}
                  </p>
                  <div className="mt-auto text-[#1A658F] flex items-center hover:underline hover:text-blue-500">
                    <FormattedMessage
                      id="meted.learn_more"
                      defaultMessage="Learn more"
                    />
                    <ChevronRightIcon className="ml-1 h-4 w-4" />
                  </div>
                </div>
              </a>
            ))}
          </div>

          <div className="mt-8 flex justify-center">
            <a
              href="https://learn.meted.ucar.edu/#/catalog"
              className="inline-flex w-48 float-none mx-auto my-4 items-center justify-center bg-[#1A658F] px-6 py-3 text-base font-medium text-white shadow-lg hover:bg-cyan-600 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 rounded-md"
            >
              <FormattedMessage id="meted.view_all" defaultMessage="View All" />
              <ChevronRightIcon className="ml-2 h-4 w-4" />
            </a>
          </div>
        </div>
      </section>

      {/* DONATE */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid gap-6 grid-cols-1 md:grid-cols-2">
          <Link
            to="https://friendsofthenationalcenter.org/donate-ucar-comet-meted/"
            className=""
          >
          <div style={{backgroundImage: "url('/static/img/donation_summary_graphic.jpg')"}} className="flex justify-center items-center">
            <img src={process.env.PUBLIC_URL + "/static/img/donation_summary_graphic.jpg"} alt="Donation Summary Graphic"
              className="w-full h-auto shadow-md rounded-lg object-cover"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </div>
          </Link>
          <div className="mb-8 flex flex-col items-center text-left justify-center space-y-8">
            <h2 className="text-3xl font-bold tracking-tight text-[#1A658F]">
              <FormattedMessage
                id="donate.support_earth_sciences"
                defaultMessage="Support Earth Sciences Expertise, together."
              />
            </h2>
            <p className="text-lg mt-2 text-muted-foreground leading-loose">
              <FormattedMessage
                id="donate.comet_35_years"
                defaultMessage="The COMET&reg; Program is celebrating 35 years of serving the
              geosciences community."
              />
            </p>
            <span className="text-lg mt-2 text-muted-foreground leading-loose">
              <FormattedMessage
                id="donate.free_education_materials"
                defaultMessage="We develop thousands of free education &amp;
              training materials for weather enthusiasts, educators,
              professionals - and everyone in between."
              />
            </span>
            <p className="text-lg mt-2 text-muted-foreground leading-loose">
              <FormattedMessage
                id="donate.tax_deductible_donation"
                defaultMessage="Your tax deductible donation supports free access to more than
              1,000 lessons and resources, on our renowned MetEd learning platform."
              />
            </p>
            <Link
              to="https://friendsofthenationalcenter.org/donate-ucar-comet-meted/"
              className="inline-flex w-48 float-none mx-auto my-4 items-center justify-center bg-[#1A658F] px-6 py-3 text-base font-medium text-white shadow-lg hover:bg-cyan-600 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 rounded-md"
            >
              <FormattedMessage
                id="donate.donate_now"
                defaultMessage="Donate"
              />
              <ChevronRightIcon className="ml-2 h-4 w-4" />
            </Link>

          </div>
          
        </div>
      </section>

      {/* QUICK LINKS */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 border-t border-gray-200">
        <div className="mb-8 max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold tracking-tight text-[#1A658F]">
            <FormattedMessage
              id="meted.quick_links"
              defaultMessage="Quick Links"
            />
          </h2>

          <div className="my-4 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            <div className="border rounded-lg bg-[#1A658F] text-white text-center py-2 shadow-md hover:-translate-y-1 transition-all duration-100">
              <Link to="/help" className="flex flex-col items-center">
                <div className="p-2">
                  <h1 className="text-lg font-bold">
                    <FormattedMessage
                      id="meted.help_center"
                      defaultMessage="Support & FAQs"
                    />
                  </h1>
                  <p className="text-sm p-2">
                    <FormattedMessage
                      id="meted.help_center_description"
                      defaultMessage="Technical Support and Frequently Asked Questions"
                    />
                  </p>
                  <div className="flex justify-center">
                    <ArrowTopRightOnSquareIcon className="h-8 w-8 text-white" />
                  </div>
                </div>
              </Link>
            </div>

            <div className="border rounded-lg bg-[#1a658f] text-white text-center py-2 shadow-md hover:-translate-y-1 transition-all duration-100">
              <Link
                to="https://www.comet.ucar.edu/"
                className="flex flex-col items-center"
              >
                <div className="p-2">
                  <h1 className="text-lg font-bold">
                    <FormattedMessage
                      id="meted.comet_program"
                      defaultMessage="The COMET Program"
                    />
                  </h1>
                  <p className="text-sm p-2">
                    <FormattedMessage
                      id="meted.comet_program_description"
                      defaultMessage="Learn more about the COMET Program and its educational initiatives"
                    />
                  </p>
                  <div className="flex justify-center">
                    <ArrowTopRightOnSquareIcon className="h-8 w-8 text-white" />
                  </div>
                </div>
              </Link>
            </div>

            <div className="border rounded-lg bg-[#1a658f] text-white text-center py-2 shadow-md hover:-translate-y-1 transition-all duration-100">
              <Link to="/transcripts" className="flex flex-col items-center">
                <div className="p-2">
                  <h1 className="text-lg font-bold">
                    <FormattedMessage
                      id="meted.my_meted_records"
                      defaultMessage="My MetEd Records"
                    />
                  </h1>
                  <p className="text-sm p-2">
                    <FormattedMessage
                      id="meted.my_meted_records_description"
                      defaultMessage="Download your legacy transcripts, certificates, and queue here"
                    />
                  </p>
                  <div className="flex justify-center">
                    <ArrowTopRightOnSquareIcon className="h-8 w-8 text-white" />
                  </div>
                </div>
              </Link>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </section>
  );
};

function mapStateToProps({ user, viewer, dispatch }) {
  return { user, viewer, dispatch };
}

export default connect(mapStateToProps)(JoinFeaturedContainer);
